<template>
  <div class="columns is-centered cont  is-mobile">
    <div class="column is-11">
      <div class="field">
        <label class="label">Nombre completo</label>
        <div class="control has-icons-left">
          <input class="input blue-bc" type="text" placeholder="Ej- Rodrigo Pérez" />
          <span class="icon is-small is-left">
            <i class="fas fa-user"></i>
          </span>
        </div>
      </div>
      <div class="field">
        <label class="label">Restaurante</label>
        <div class="control has-icons-left">
          <input class="input blue-bc" type="text" placeholder="Ej- Tacos Pérez" />
          <span class="icon is-small is-left">
            <i class="fas fa-utensils"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Correo electrónico</label>
        <div class="control has-icons-left">
          <input class="input is-info" type="email" placeholder="Ej- tacosperez@gmail.com" />
          <span class="icon is-small is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Número de sucursales</label>
        <div class="control has-icons-left">
          <input class="input is-info" type="text" placeholder="Ej- 2" />
          <span class="icon is-small is-left">
            <i class="fas fa-hashtag"></i>
          </span>
        </div>
      </div>

      <div class="field">
        <label class="label">Servicio</label>
        <div class="control has-icons-left">
          <div class="select is-primary">
            <select>
              <option>Premium (recomendado) $1,200 anual</option>
              <option>Básico $960 anual</option>
            </select>
            <span class="icon is-small is-left">
              <i class="fas fa-fire"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Mensaje</label>
        <div class="control">
          <textarea class="textarea green-bc" placeholder="¿Alguna duda o comentario?"></textarea>
        </div>
      </div>
      <div class="field">
        <label class="label">(Opcional) Subir Menú y Logo para hacer un QR de prueba</label>
        <div class="file is-info has-name is-fullwidth">
          <label class="file-label">
            <input class="file-input" type="file" name="Menú" />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-file-pdf"></i>
              </span>
              <span class="file-label">Menú PDF</span>
            </span>
            <span class="file-name">Subir menú en PDF</span>
          </label>
        </div>
      </div>
      <div class="field">
        <div class="file is-info has-name is-fullwidth">
          <label class="file-label">
            <input class="file-input" type="file" name="Logo" />
            <span class="file-cta ">
              <span class="file-icon">
                <i class="fas fa-file-image"></i>
              </span>
              <span class="file-label">Logo JPG  </span>
            </span>
            <span class="file-name">Subir logo en JPG</span>
          </label>
        </div>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button class="button green-bg is-large">Solicitar</button>
        </div>
        <div class="control">
          <button class="button is-light is-large" @click="$router.go(-1)">Regresar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solicitar_QR",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cont {
  padding-top: 95px;
}
.green-bg {
  background-color: #9ed96b;
  color: white;
}
.green-bc {
  border-color: #9ed96b;
}
.light-blue-bc {
  border-color: #095168;
}
.blue-bc {
  border-color: #0d0635;
}
</style>
